export default __webpack_public_path__ + "static/media/check-white.d82d7329.svg";